import { 
  REQUEST_MY_BOOKINGS,
  RECEIVE_MY_BOOKINGS,
  REQUEST_MY_BOOKING_DETAILS,
  RECEIVE_MY_BOOKING_DETAILS,
  REQUEST_MY_BOOKING_COMPANIONS,
  RECEIVE_MY_BOOKING_COMPANIONS,
  UPDATE_MY_BOOKING_COMPANIONS,
  COMPLETE_UPDATE_MY_BOOKING_COMPANIONS,
  REQUEST_DELETE_SAVED_INFO,
  RECEIVE_DELETE_SAVED_INFO,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  myBookings: [],
  companions: [],
  updateMessage: '',
  bookingDetails: null,
  loading: true,
};

function myBookingsReducer(state = INITIAL_STATE, action) {
  switch(action.type) {
    case REQUEST_MY_BOOKINGS: {
      return {
        ...state,
        loading: true
      };
    }
    case RECEIVE_MY_BOOKINGS: {
      return {
        ...state,
        myBookings: action.bookings,
        loading: false,
      };
    }
    case REQUEST_MY_BOOKING_DETAILS: {
      return {
        ...state,
        loading: true,
      };
    }
    case RECEIVE_MY_BOOKING_DETAILS: {
      return {
        ...state,
        bookingDetails: action.bookingDetails,
        loading: false,
      };
    }
    case REQUEST_MY_BOOKING_COMPANIONS: {
      return {
        ...state,
        loading: true,
      };
    }
    case RECEIVE_MY_BOOKING_COMPANIONS: {
      return {
        ...state,
        companions: action.companions,
        loading: false,
      };
    }
    case UPDATE_MY_BOOKING_COMPANIONS: {
      return {
        ...state,
        loading: true,
        updateMessage: '',
      };
    }
    case COMPLETE_UPDATE_MY_BOOKING_COMPANIONS: {
      return {
        ...state,
        loading: false,
        updateMessage: action.message,
      };
    }
    case REQUEST_DELETE_SAVED_INFO: {
      return {
        ...state,
        loading: true,
      };
    }
    case RECEIVE_DELETE_SAVED_INFO: {
      return {
        ...state,
        loading: false,
        updateMessage: action.message,
      };
    }
    default:
      return state;
  }
}

export default myBookingsReducer;